import * as Sentry from '@sentry/react'

import { beforeBreadcrumb, beforeSend } from '@/shared/sentry'
import { SENTRY_DENY_URLS, SENTRY_IGNORE_ERRORS } from '@/shared/sentry/filters'
export function initSentry() {
  Sentry.init({
    dsn: import.meta.env.VITE_APP_SENTRY_DSN,
    environment: import.meta.env.VITE_APP_ENV ?? 'development',
    release: import.meta.env.VITE_APP_VERSION,
    enabled: import.meta.env.VITE_APP_ENV === 'production',
    // enabled: true,
    ignoreErrors: SENTRY_IGNORE_ERRORS,
    denyUrls: SENTRY_DENY_URLS,

    integrations: [
      Sentry.breadcrumbsIntegration({
        xhr: false,
        fetch: false,
        dom: false,
      }),
    ],
    maxBreadcrumbs: 100,
    beforeSend: beforeSend,
    beforeBreadcrumb: beforeBreadcrumb,
  })
}
